import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import { localeStringActions } from 'actions/api/localeStrings';
import MaterialTextField from 'components/util/materialTextField';
import { debounce } from 'lodash';
import LodIcon from 'components/util/lodIcon';
import MaterialSelect from 'components/util/materialSelect';
import Pagination from 'components/pagination';
import classnames from 'classnames';
import UnverifiedRow from './unverifiedRow';
import VerifiedRow from './verifiedRow';

class PartnerDashboard extends Component {
  constructor(props) {
    super(props);
    this.languageOptions = this.generateLanguageOptions();
    this.state = {
      page: 1,
      searchString: '',
      languageSelection: props.currentUser.language_id,
      verifiedState: false,
      showEmptyText: false,
      classificationsState: false
    };
  }

  componentWillMount() {
    this.searchStrings();
  }

  searchStrings = async ({ background = false } = {}) => {
    await this.props.dispatch(
      localeStringActions.search({
        data: {
          language_id: this.state.languageSelection,
          verified: this.state.verifiedState,
          classifications: this.state.classificationsState,
          meta: {
            pagination: { page: this.state.page },
            text_search: this.state.searchString.trim() || null,
            sort:
              this.state.classificationsState === true
                ? null
                : [{ order_by: 'base_string_id', order_type: 'DESC' }]
          }
        },
        background
      })
    );
    this.setState({ showEmptyText: true });
  };

  generateLanguageOptions = () => {
    let options = [];
    this.props.languages
      .sort((a, b) => a.title_english.localeCompare(b.title_english))
      .forEach(language => {
        options.push({
          label: language.title_english,
          value: language.id,
          icon: (
            <div
              style={{
                backgroundSize: 'contain',
                backgroundPosition: '50%',
                backgroundRepeat: 'no-repeat',
                width: 34,
                height: 26,
                verticalAlign: 'middle'
              }}
              className={`img-thumbnail flag flag-icon-background flag-icon-${language.alpha2}`}
            />
          )
        });
      });

    return options;
  };

  debouncedSearch = debounce(this.searchStrings, 300);

  onSearchChange = ({ target }) => {
    this.setState({ searchString: target.value, page: 1 });

    setTimeout(this.debouncedSearch);
  };

  onPageChange = page => {
    this.setState({ page });
    setTimeout(this.searchStrings);
  };

  onLanguageChange = value => {
    this.setState({ languageSelection: value, page: 1, searchString: '' });

    setTimeout(this.searchStrings);
  };

  onStringTypeChange = value => {
    this.setState({
      classificationsState: value,
      page: 1
    });

    setTimeout(this.searchStrings);
  };

  changeTab = tab => {
    this.setState({
      verifiedState: tab,
      searchString: '',
      page: 1,
      showEmptyText: false
    });

    setTimeout(this.searchStrings);
  };

  render() {
    const localeStrings = this.props.localeStrings
      .filter(
        string => this.state.verifiedState === !!string.partner_translation
      )
      .sort((a, b) => {
        if (!this.props.localeStringOrderData) {
          if (!a.base_string.bim_code) {
            return -1;
          }

          return a.base_string.bim_code.localeCompare(b.base_string.bim_code);
        } else {
          return (
            +new Date(b.base_string.created_at) -
            +new Date(a.base_string.created_at)
          );
        }
      });
    const { classificationsState } = this.state;
    const { unverifiedCount, verifiedCount } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <div>Translate</div>
          <div className={styles.unverifiedCount}>
            {unverifiedCount ? unverifiedCount + ' Unverified' : null}
          </div>
          {this.state.verifiedState === true ? (
            <div className={styles.search}>
              <LodIcon icon="search" />
              <div className={styles.searchInput}>
                <MaterialTextField
                  value={this.state.searchString}
                  onChange={this.onSearchChange}
                  hintText="Search verified translations"
                />
              </div>
            </div>
          ) : (
            <div />
          )}
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <div className={styles.containerLeft}>
              <MaterialSelect
                className={styles.languageType}
                options={this.languageOptions}
                value={this.state.languageSelection}
                onChange={this.onLanguageChange}
                disabled
              />

              <MaterialSelect
                className={styles.textType}
                options={[
                  { label: 'App Text', value: false },
                  { label: 'Element Library', value: true }
                ]}
                value={this.state.classificationsState}
                onChange={this.onStringTypeChange}
              />
            </div>

            <div className={styles.containerMiddle}>
              <div className={styles.pagination}>
                <Pagination
                  pagination={this.props.pagination}
                  onChange={this.onPageChange}
                />
              </div>
            </div>

            <div className={styles.containerRight}>
              <div className={styles.tabs}>
                <div
                  onClick={() => this.changeTab(false)}
                  className={classnames(styles.tab, {
                    [styles.active]: this.state.verifiedState === false
                  })}>
                  Unverified ({unverifiedCount})
                </div>
                <div
                  onClick={() => this.changeTab(true)}
                  className={classnames(styles.tab, {
                    [styles.active]: this.state.verifiedState === true
                  })}>
                  Verified ({verifiedCount})
                </div>
              </div>
            </div>
          </div>

          <div className={styles.tableWrapper}>
            <div className={styles.headerWrapper}>
              <table>
                <colgroup>
                  {classificationsState && <col width="5%" />}
                  <col width="30%" />
                  <col width="30%" />
                  <col width="10%" />
                </colgroup>
                <thead>
                  <tr>
                    {classificationsState && <th>Image</th>}

                    <th>English</th>
                    <th>Translation</th>
                    <th>
                      {this.state.verifiedState === true ? 'Verified' : null}
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className={styles.bodyWrapper}>
              {localeStrings.length === 0 && this.state.showEmptyText && (
                <div className={styles.emptyMsg}>
                  {this.state.verifiedState === false
                    ? "You're all up to date!"
                    : 'Nothing verified yet.'}
                </div>
              )}
              <table>
                <colgroup>
                  {classificationsState && <col width="5%" />}
                  <col width="30%" />
                  <col width="30%" />
                  <col width="10%" />
                </colgroup>
                <tbody>
                  {localeStrings.map(string => {
                    return string.partner_translation ? (
                      <VerifiedRow
                        classifications={classificationsState}
                        string={string}
                        key={string.id}
                      />
                    ) : (
                      <UnverifiedRow
                        classifications={classificationsState}
                        string={string}
                        searchStrings={this.searchStrings}
                        key={string.id}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    localeStrings: state.localeStrings.list,
    pagination: state.localeStrings.meta.pagination,
    languages: state.languages.list,
    currentUser: state.users.map[state.sessionSettings.currentUserId],
    loading: state.loader.loading,
    localeStringOrderData: state.localeStrings.meta.order_data,
    unverifiedCount: state.localeStrings.meta.unverified_count,
    verifiedCount: state.localeStrings.meta.verified_count
  };
})(PartnerDashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/partnerDashboard/index.js